<template>    
  <div class="content">
 
    <b-container fluid >
      <div>
        <card class="no-border-card mb-0 pb-0" body-classes=" p-4" >

          <b-row class="justify-content-md-center" align-v="center">
            <b-col>
              <h1 class="mb-0">Scripts</h1>
            </b-col>
            <b-col class="float-right">
              <base-button icon type="success" class="float-right"  @click="toggle_new_script_modal" >
                <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18 color_white">add</span></span>
                <span class="btn-inner--text">Create Script</span>
              </base-button>
            </b-col>
          </b-row>
        </card>

        <!-- script table -->
        <card class="no-border-card" body-classes="px-0 pb-1 mt-0 pt-0" footer-classes="pb-2" v-if="$parent.scripts.length > 0">

          <div>
            <!-- table -->
            <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
              <div>
              <ve-table :columns="columns" :table-data="tableData" :fixed-header="true" ref="scripts_table"></ve-table>
                <div class="table-pagination mt-3">
                    <ve-pagination
                        :total="totalCount"
                        :page-index="pageIndex"
                        :page-size="pageSize"
                        @on-page-number-change="pageNumberChange"
                        @on-page-size-change="pageSizeChange"
                    />
                </div>

              </div>
            </card>
            <!-- table -->
          </div>
          
        </card>
        <!-- script table -->

      </div>

      <!-- new script modal -->
      <div>
      
        <modal :show.sync="modals.new_script.show_modal" class="modal-xl" body-classes="p-0" id="new_script_modal" ref="new_script_modal">

          <card
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <div v-if="modals.new_script.editing_existing_script && modals.new_script.editing_existing_script === true">
                  <h2>Edit Script</h2>
                  <p>{{modals.new_script.form_data.script_name}}</p>
                </div>
                <div v-else>
                  <h2>Create New Script</h2>
                </div>
                
              </div>

              <div v-if="modals.new_script.errors.length > 0">
                <b-alert show variant="danger" v-for="new_script_errors in modals.new_script.errors" :key="new_script_errors"
                                :error_text="new_script_errors" >
                  <strong>{{new_script_errors}}</strong>
                </b-alert>
              </div>

              <b-form role="form">
                <base-input alternative
                            :disabled="modals.new_script.editing_existing_script"
                            v-model="modals.new_script.form_data.script_name"
                            class="mb-3"
                            placeholder="Script Name"
                            prepend-icon="drive_file_rename_outline">
                </base-input>
                
                <b-form-group label="Active" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                  <base-switch class="mr-1" v-model="modals.new_script.form_data.is_active" ></base-switch>
                </b-form-group>

                <!--
                <base-input label="Script Type" :disabled="modals.new_script.editing_existing_script">
                  <el-select v-model="modals.new_script.form_data.script_type" filterable
                            placeholder="Type">
                    <el-option v-for="option in modals.new_script.script_type_options"
                              :key="option.label"
                              :label="option.label"
                              :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>

                 <div v-if="modals.new_script.editing_existing_script !== true">
                  <base-input alternative
                  v-model="modals.new_script.form_data.script_description"
                  class="mb-3"
                  placeholder="Description"
                  prepend-icon="description">
                </base-input>
                </div>


                -->
                
                <base-input label="Script Text Fallback" prepend-icon="rate_review">
                  <textarea class="form-control" id="script_text_fallback" v-model="modals.new_script.form_data.script_text_fallback" rows="3"></textarea>
                </base-input>

                <base-input label="Script Text" prepend-icon="integration_instructions" class="question_margin_bottom">
                  <textarea class="form-control" id="script_text_handlebars" v-model="modals.new_script.form_data.script_text_handlebars" rows="3"></textarea>
                </base-input>
                <span class="material-icons material-icons-outlined md-18 color_blue question_margin_bottom_add" v-b-tooltip.hover.right title="Use handlebars. Contact admin for tutorial.">help</span>

                <base-input alternative
                  v-model="modals.new_script.form_data.sms_attachment"
                  class="mb-3"
                  placeholder="SMS Attachment URL"
                  prepend-icon="image">
                </base-input>
                <div class="new_script_image_contain" v-if="modals.new_script.form_data.sms_attachment">
                  <div v-if="modals.new_script.form_data.sms_attachment.endsWith('.jpg') || modals.new_script.form_data.sms_attachment.endsWith('.gif') || modals.new_script.form_data.sms_attachment.endsWith('.png')">
                    <img  v-if="modals.new_script.form_data.sms_attachment" :src="modals.new_script.form_data.sms_attachment" alt="SMS image preview. invalid URL or file not accessible to web." class="w-25">
                  </div>
                  <div v-if="modals.new_script.form_data.sms_attachment.endsWith('.mp4') || modals.new_script.form_data.sms_attachment.endsWith('.mpeg') " class="w-25">
                    <video controls class="w-25">
                      <source :src="modals.new_script.form_data.sms_attachment" type="video/mp4">
                    </video>
                  </div>
                  <div v-if="modals.new_script.form_data.sms_attachment.endsWith('.vcf')" class="w-25">
                    <p><a :href="modals.new_script.form_data.sms_attachment">Download contact card</a></p>
                  </div>
                  <div v-if="modals.new_script.form_data.sms_attachment.endsWith('.ics') || modals.new_script.form_data.sms_attachment.endsWith('.icalendar') || modals.new_script.form_data.sms_attachment.endsWith('.ical')" class="w-100">
                    <p><a :href="modals.new_script.form_data.sms_attachment">Download calendar event</a></p>
                  </div>
                  <div v-if="modals.new_script.form_data.sms_attachment.endsWith('.mp3') || modals.new_script.form_data.sms_attachment.endsWith('.wav') " class="w-25">
                    <audio class="w-25">
                      <source :src="modals.new_script.form_data.sms_attachment" type="audio/mp3" v-if="modals.new_script.form_data.sms_attachment.endsWith('.mp3')">
                      <source :src="modals.new_script.form_data.sms_attachment" type="audio/wav" v-if="modals.new_script.form_data.sms_attachment.endsWith('.wav')">
                    </audio>
                  </div>
                 
                </div>

              </b-form>

              

          </card>

          
      

         <template slot="footer">
          <div v-if="modals.new_script.editing_existing_script && modals.new_script.editing_existing_script === true">
            <base-button type="danger" @click="reset_modal_data()">Cancel</base-button>
            <base-button type="success" @click="submit_new_script()" :disabled="modals.new_script.is_busy" ref="create_script_button">Edit Script <span class="material-icons material-icons-outlined md-18 color_white">edit</span> </base-button>
          </div>
          <div v-else>
            <base-button type="danger" @click="reset_modal_data()">Cancel</base-button>
            <base-button type="success" @click="submit_new_script()" :disabled="modals.new_script.is_busy" ref="create_script_button">Create Script <span class="material-icons material-icons-outlined md-18 color_white">add</span> </base-button>
          </div>
          
        </template>
        </modal>


      </div>


    </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import clientPaginationMixin from './PaginatedTables/clientPaginationMixin'
import swal from 'sweetalert2';
import { BModal } from 'bootstrap-vue'
const handlebars = require("handlebars");
import moment from 'moment'




export default {
  mixins: [clientPaginationMixin],
  components: {
    BModal,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      backdoor: 0,
      is_inside_change_data_callback: false,
      changed_row_index_numbers: [],
      pageIndex: 1,
      pageSize:10,

      columns: [

        {
            field: "script_name",
            key: "script_name",
            title: "Name",
            width: 120,
            align: "left",
            renderBodyCell: ({ row, column, index }, h) => {
              if(!row.date_created) {
                return <div>{row.script_name}</div>
              } else {
                return (
                  <div v-b-tooltip={moment(row.date_created).format('MM/DD/YYYY')}>{row.script_name}</div>
                )
              }
            }
            
        },
        {
            field: "date_created",
            key: "date_created",
            title: "Date",
            width: 90,
            align: "left",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              if(!row.date_created) {
                return
              } else {
                return moment(row.date_created).format('MM/DD/YYYY');
              }
            }
        },

        {
            field: "is_active",
            key: "is_active",
            title: "Active",
            align: "left",
            width: 80,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              
              let real_row_index
              if(this.pageIndex === 1) {
                real_row_index = ++rowIndex
              } else {
                rowIndex = rowIndex +1
                real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
              }
      
              return (
              
                <div slot-scope="{real_row_index, row}" class="d-flex" >
                  <base-switch class="mr-1" v-model={this.$parent.scripts[real_row_index-1].is_active}  onTrigger_function={() => this.change_this_active_status((real_row_index-1),this.$parent.scripts[real_row_index-1])}  ></base-switch> 
                </div>
                
              )
                //return <is_active_switch row={row} index={index} />;
                
              
            }
        },
        {
            field: "script_text_handlebars",
            key: "script_text_handlebars",
            title: "Text",
            align: "left",
           renderBodyCell: ({
                row,
                column,
                rowIndex
            }, h) => {

                if (typeof row.script_text_handlebars === 'undefined') {
                    if (row.script_text_handlebars === null && typeof row.script_text_fallback !== 'undefined' && row.script_text_fallback !== null) {
                        return (
                          <p class = "font_size_14" >{row.script_text_fallback}</p>
                        )
                    } else {
                        return null
                    }
                } else {
                    let render_handlebars_object = {
                        active_contact: {
                            first_name: 'First',
                            last_name: "Last",
                            city: "City",
                            state: "State",
                            zip: "Zip",
                            gender: "Male"
                        },
                        active_user: this.$parent.active_user || null
                    }

                    let template = handlebars.compile(row.script_text_handlebars + '');

                    let this_script = template(render_handlebars_object);

                    return ( 
                        <p class = "font_size_14" >{this_script}</p>
                    )
                }

            }
        },
        {
            field: "sms_attachment",
            key: "sms_attachment",
            title: "Attachment",
            align: "right",
            renderBodyCell: ({ row, column, rowIndex }, h) => {

              if(typeof row.sms_attachment !== 'undefined' && row.sms_attachment !== null) {
                if(row.sms_attachment.toUpperCase().endsWith('.JPG')) {
                  return (
                    <img src={row.sms_attachment} class='small_width'></img>
                  )
                } else if(row.sms_attachment.toUpperCase().endsWith('.MP4')) {
                  return (
                    <video controls class='small_width'>
                        <source src={row.sms_attachment} type="video/mp4"></source>
                    </video>
                  )
                } else if(row.sms_attachment.toUpperCase().endsWith('.VCF')) {
                  return (
                    <p><a href={row.sms_attachment} target="_new">Download contact card</a></p>
                  )
                } else if(row.sms_attachment.toUpperCase().endsWith('.ICS') || row.sms_attachment.toUpperCase().endsWith('.ICALENDAR') || row.sms_attachment.toUpperCase().endsWith('.ICAL')) {
                  return (
                    <p><a href={row.sms_attachment} target="_new">Download calendar event</a></p>
                  )
                } else if(row.sms_attachment.toUpperCase().endsWith('.MP3') ) {
                  return (
                    <audio class='small_width'>
                      <source src={row.sms_attachment} type="audio/mp3"></source>
                    </audio>
                  )
                } else if(row.sms_attachment.toUpperCase().endsWith('.WAV') ) {
                  return (
                    <audio class='small_width'>
                      <source src={row.sms_attachment} type="audio/wav"></source>
                    </audio>
                  )
                } else {
                  return null
                }

              } else {
                return null
              }

             
           }
        },
        {
            field: "edit",
            key: "edit",
            title: "Edit Script",
            width: 100,
            align: "right",
             renderBodyCell: ({ row, column, rowIndex }, h) => {
               let real_row_index
                if(this.pageIndex === 1) {
                  real_row_index = ++rowIndex
                } else {
                  rowIndex = rowIndex +1
                  real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
                }

                return (
                  <base-button icon type="success" class="edit_button" onClick={() => this.edit_this((real_row_index-1), row)}>
                    <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18 color_white">edit</span></span>
                  </base-button>
                )
             }
        },
      ],



      modals: {
        new_script: {
          show_modal: false,
          editing_existing_script: false,
          is_editing_existing_index: null,
          this_row_primary_key_uuid: null,
          is_busy: false,
          script_type_options: [{
            value:'SMS',
            label:'SMS'
          }],
          errors: [

          ],
          default_form_data: {

            "org_id":this.$parent.active_org.org_id,
            "script_type":"SMS",
            "user_uuid_created":this.$parent.active_user.user_uuid,
            //"script_uuid":null,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "script_name":null,
            "script_description":null,
            "script_text_fallback":null,
            "script_text_handlebars":null,
            //"date_created":"2021-08-17T23:58:52.724000000Z",
            //"last_modified":"2021-08-17T23:58:52.724000000Z",
            "is_active":true,
            "sms_attachment":null
            
          },
          form_data: {
            "org_id":this.$parent.active_org.org_id,
            "script_type":"SMS",
            "user_uuid_created":this.$parent.active_user.user_uuid,
            //"script_uuid":null,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "script_name":null,
            "script_description":null,
            "script_text_fallback":null,
            "script_text_handlebars":null,
            //"date_created":"2021-08-17T23:58:52.724000000Z",
            //"last_modified":"2021-08-17T23:58:52.724000000Z",
            "is_active":true,
            "sms_attachment":null
          }
        }
      }
    };
  },
  computed: {
    totalCount() {
        return this.$parent.scripts.length || 0
    },
    tableData() {
        this.backdoor
        const { pageIndex, pageSize } = this;
        return this.$parent.scripts.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    }
  },
  created() {
    window.addEventListener("resize", this.window_resize_function);
    this.window_resize_function()
  },
  destroyed() {
    window.removeEventListener("resize", this.window_resize_function);
  },
  methods: {
    calculate_window_width() {
      var this_width = 0
      if( typeof( window.innerWidth ) == 'number' ) {
        //Non-IE
        this_width = window.innerWidth;
      } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
        //IE 6+ in 'standards compliant mode'
        this_width = document.documentElement.clientWidth;
      } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
        //IE 4 compatible
        this_width = document.body.clientWidth;
      }
      return this_width
    },
    //mobile hide date i think
    window_resize_function(event) {
      //if(event.type && event.type === 'resize') {
        let this_width =  this.calculate_window_width() 

        if(this_width <= 600) {
          this.hideColumns(['date_created'],'scripts_table')
        } else {
          this.showColumns(['date_created'],'scripts_table')
        } 
      //}
    },
    hideColumns(keys,table_ref) {
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }

      //make sure element exists
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].hideColumnsByKeys(keys);
        }
      })
      
    },
    // show cloumns
    showColumns(keys,table_ref) {   //array, ref
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].showColumnsByKeys(keys)
        }
        
      })
    },

    edit_this(index,row) {
      try {
        //check state is not messed up
        console.log
        if(row.script_uuid.toUpperCase() !== this.$parent.scripts[index].script_uuid.toUpperCase()) {
          console.log('state does not align?')
          return this.reset_modal_data()        
        }

        //try to just recycle ? toggle_new_script_modal
        this.modals.new_script.editing_existing_script = true
        this.modals.new_script.form_data = this.$parent.scripts[index]
        this.modals.new_script.this_row_primary_key_uuid = row.script_uuid || null 
        this.modals.new_script.is_editing_existing_index = index

        this.modals.new_script.show_modal = true

      } catch(e) {
        console.log(e)
        return this.reset_modal_data()
      }
      
    },


   
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },

    change_this_active_status: function(index,row) {

      this.$nextTick(() => {
        //so dont do two at once
        if(!this.changed_row_index_numbers.includes(index)) {
          this.changed_row_index_numbers.push(index)
          this.post_new_row_data(index,row)
        } else {
          return swal.fire({
              title: `Warning`,
              text: 'Error previous request still loading refresh and try again',
              buttonsStyling: false,
              icon: 'warning'
            })
        }
      })
    },
    removeItemAll: function(arr, value) {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    },
    post_new_row_data: function(index,row) {
      //let this_row_elements = document.getElementsByClassName("el-table__row")
      //this_row_elements[index].classList.add("table_row_loading");

      if(!this.$parent.active_user.permissions.includes('scripts:create')) {
        console.log('no scripts:create dont allow edits')
        return
      }
      

    //TODO is_active bug? i dont know why the status is backwards/not showing in row but it is in the actual parent update
      setTimeout(() => {
        //there is a timing bug vue is fucked?
        //console.log('debug is_active')
        //console.log(JSON.stringify(row))
        //console.log(JSON.stringify(this.$parent.scripts[index]))

        try {
          //console.log('row index that have been updated ' + JSON.stringify(index))

          row.user_uuid_last_modified = this.$parent.active_user.user_uuid

          axios.post('https://'+this.$parent.use_this_api_domain+'/scripts/create', row, {
            headers: {
              'Authorization': 'Bearer ' + this.$parent.active_user_jwt
            }
          })
          .then((response,error) => {
            if(response) {
              //console.log('new list debug response')
              //console.log(JSON.stringify(response))

              this.$parent.scripts[index] = response.data

              var new_active_campaign = null
             
              //check to see if active_campaign contains this script_uuid
              try {
                if(this.$parent.active_campaign && this.$parent.active_campaign.scripts && this.$parent.active_campaign.scripts.length && this.$parent.active_campaign.scripts.length > 0) {
                  if(this.$parent.active_campaign.scripts.includes(response.data.script_uuid)) {
                    //do nothing
                  } else {
                    //loop through campaigns and see if any match this script_uuid
                    if(this.$parent.outbound_campaigns && this.$parent.outbound_campaigns.length && this.$parent.outbound_campaigns.length > 0) {
                      //outbound_campaign_uuid
                      this.$parent.outbound_campaigns.forEach(single_campaign => {
                        if(single_campaign.scripts && single_campaign.scripts.length && single_campaign.scripts.length > 0) {
                          if(single_campaign.scripts.includes(single_campaign.scripts)) {
                            new_active_campaign = single_campaign
                          }
                        }
                      });
                    }

                    if(new_active_campaign && new_active_campaign !== null && new_active_campaign.list_uuids && new_active_campaign.list_uuids.length && new_active_campaign.list_uuids.length > 0) {
                      //set_this_active_list,set_this_active_script,recursive_loop_count,recursive_time
                      //set_this_active_list,set_this_active_script,recursive_loop_count,recursive_time,set_this_active_campaign_uuid
                      this.$parent.cascade_updates_on_new_active_campaign( new_active_campaign.list_uuids[0], response.data.script_uuid, 0, 1000, new_active_campaign.campaign_uuid)
                    }
                  }
                }
              } catch(e) {
                //new scripts reload do nothing
                console.log(e)
              }

              
            }
            if(error) {
              console.log('debug update contact list error')
              console.log(JSON.stringify(error))
            }
            this.removeItemAll(this.changed_row_index_numbers,index)
          })

        } catch(e) {
          console.log(e)
          // console.log('finally')
          // this.changed_row_index_numbers = []
          // this.is_inside_change_data_callback = false
          this.removeItemAll(this.changed_row_index_numbers,index)
        }


      }, 200);

    },
    toggle_new_script_modal: function() {
      this.modals.new_script.show_modal = true
      //this.$refs['new_script_modal'].toggle('#toggle_new_script_modal')
    },

    submit_new_script: function(this_event) {

      if(!this.$parent.active_user.permissions.includes('scripts:create')) {
        console.log('no scripts:create dont allow edits')
        this.reset_modal_data()
        return swal.fire({
          title: `Warning`,
          text: 'Error you do not have permissions to create or edit scripts',
          buttonsStyling: false,
          icon: 'warning'
        })
        
      }

      //make sure has a few details
      try {

        if(typeof this.modals.new_script !== 'undefined' && typeof this.modals.new_script.form_data !== 'undefined' && typeof this.modals.new_script.form_data.sms_attachment !== 'undefined' && this.modals.new_script.form_data.sms_attachment !== null ) {

          //2210 remove just allow all because we now allow params and customs like {{something}}
          if(!this.modals.new_script.form_data.sms_attachment.toUpperCase().startsWith('HTTPS://')) {
                //needs to be a url let's allow non ssl 
                console.log('media url does not start with https://')
                this.modals.new_script.errors.push("Bad file url. Must start with https://")
          }
        }
          /*
            if(this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.JPG') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('}}') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.GIF') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.PNG') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.MOV') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.MP4') || 
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.MPEG') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.ICALENDAR') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.ICAL') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.ICS') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.MP3') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.WAV') ||
            this.modals.new_script.form_data.sms_attachment.toUpperCase().endsWith('.VCF') 
            ) {
              //https
             
            } else {
              console.log('debug bad file ending format ' + this.modals.new_script.form_data.sms_attachment || null)
              this.modals.new_script.errors.push("Bad file url. Is not accepted format.")
            }
            */

        
        if(!this.modals.new_script.form_data.script_name) {
          this.modals.new_script.errors.push("Must have a script name")
        } else  {
          this.modals.new_script.errors = this.modals.new_script.errors.filter(e => e !== "Must have a script name")
        }

        if(this.modals.new_script.form_data.script_name && this.modals.new_script.form_data.script_name.length < 7) {
          this.modals.new_script.errors.push("Please write a longer script name, at least 8 characters")
        } else {
          this.modals.new_script.errors = this.modals.new_script.errors.filter(e => e !== "Please write a longer script name, at least 8 characters")
        }

        if(!this.modals.new_script.form_data.script_type) {
         this.modals.new_script.form_data.script_type = 'SMS'
        }

        if(!this.modals.new_script.form_data.script_description) {
          this.modals.new_script.form_data.script_description = this.modals.new_script.form_data.script_name
        }

        if(!this.modals.new_script.form_data.script_text_fallback) {
          this.modals.new_script.errors.push("Must have basic script text")
        } else {
          this.modals.new_script.errors = this.modals.new_script.errors.filter(e => e !== "Must have basic script text")
        }

        if(this.modals.new_script.form_data.is_active === null) {
          this.modals.new_script.errors.push("Must select active status")
        } else {
          this.modals.new_script.errors = this.modals.new_script.errors.filter(e => e !== "Must select active status")
        }
     
      } catch(e) {
        console.log(e)
        this.modals.new_script.is_busy = false
        return swal.fire({
              title: `Warning`,
              text: 'Error creating new script',
              buttonsStyling: false,
              icon: 'warning'
            })
      }
      
      if(this.modals.new_script.errors.length > 0) {
        //do nothing
        this.modals.new_script.is_busy = false
      } else {


        this.modals.new_script.form_data.org_id =  this.modals.new_script.default_form_data.org_id
        this.modals.new_script.form_data.user_uuid_last_modified =  this.modals.new_script.default_form_data.user_uuid_last_modified

        if(typeof this.modals.new_script.form_data.user_uuid_created === 'undefined' || this.modals.new_script.form_data.user_uuid_created === null) {
          this.modals.new_script.form_data.user_uuid_created =  this.modals.new_script.default_form_data.user_uuid_created
        }

        //show modal as loading
        this.modals.new_script.is_busy = true

        //post the data
        axios.post('https://'+this.$parent.use_this_api_domain+'/scripts/create',  
          this.modals.new_script.form_data, {
          headers: {
            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
          }
        })
        .then(response => {

          if(response.status === 200) {
            
            //is editing existing or is new
            if(typeof this.modals.new_script.editing_existing_script !== 'undefined' && this.modals.new_script.editing_existing_script === true) {

              let update_this_parent_index = null
              this.$parent.scripts.forEach( (parent_script,index) => {
                if(parent_script.script_uuid === this.modals.new_script.this_row_primary_key_uuid) {
                  update_this_parent_index = index
                }
              })

              if(update_this_parent_index !== null) {
                this.$parent.scripts[update_this_parent_index] = response.data
                this.backdoor++
              } else {
                console.log('debug could not find this script uuid in parent? state error')
                return swal.fire({
                  title: `Warning`,
                  text: 'Error updating script. state error contact admin.',
                  buttonsStyling: false,
                  icon: 'warning'
                })
              }

            } else {

              this.$parent.scripts.unshift(response.data)
            }

            return this.reset_modal_data()

          } else {
            this.reset_modal_data()
            return swal.fire({
              title: `Warning`,
              text: 'Error creating new script',
              buttonsStyling: false,
              icon: 'warning'
            })
          }

        })
        .catch(error =>  {
          console.log(error.response.data)
          this.reset_modal_data()
          return swal.fire({
            title: `Warning`,
            text: 'Error creating new script',
            buttonsStyling: false,
            icon: 'warning'
          })
          
        })
        
      }

    },
    reset_modal_data: function() {
          this.modals.new_script.form_data = this.modals.new_script.default_form_data 

          //clear any erors 
          this.modals.new_script.errors = []

          //close
          this.modals.new_script.show_modal = false
          this.modals.new_script.is_busy = false
          this.modals.new_script.editing_existing_script = false
          this.modals.new_script.is_editing_existing_index = null
          this.modals.new_script.this_row_primary_key_uuid = null
    }

   
  }
};


</script>
<style>
.btn.edit_button {
  padding: 3px 10px 3px 10px;
  font-size: 12px;
  vertical-align: text-top;
  text-align: right;
}
.material-icons {
  vertical-align: text-top;
}
.color_blue {
  color:var(--light_blue);
}
.question_margin_bottom fieldset {
  margin-bottom:5px;
}
.question_margin_bottom_add {
  margin-bottom: 15px;
}
  .small_width {
    max-width: 150px;
  }
  .small_width img, .small_width video , .small_width audio {
    width: 100%;
    display:inline-block;
  }
  .no-border-card .card-footer{
    border-top: 0;
  }
  .table_row_loading {
    opacity: .5;

  }
  div.el-table  .table_row_loading {
    background-color: var(--gray) !important;
  }
  .card .table td, .card .table th, .card .el-table td, .card .el-table th {
    padding-left: 5px;
    padding-right:5px;
  }
  .font_size_14 {
    font-size: 14px;
  }
</style>
